import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetWithDatabaseAdapts } from './tabular-type.dataset.adapter';
import { SqlServerTableDataset } from 'shell-models-lib';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlServerTableDataset),
    asynchronous: true,
    adapts: {
        ...tabularTypeDatasetWithDatabaseAdapts,
        properties: {
            ...tabularTypeDatasetWithDatabaseAdapts.properties,
            connectionProperties: GlobalVariables.connectionPropertiesForSql ? '*' : undefined
        }
    }
})
export class SqlServerTableDatasetAdapter extends TabularTypeDatasetAdapter<SqlServerTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SqlServerTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(SqlServerTableDataset).name,
            undefined,
            undefined,
            undefined,
            undefined,
          __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? SqlServerTableDataset.DATABASE : undefined);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SqlServerTableDataset): Promise<SqlServerTableDataset> {
        return await this._toModelInternal(modelDatasetResource,
            dataset,
            SqlServerTableDataset.MODEL,
            undefined,
            undefined,
            undefined,
            undefined,
          __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? SqlServerTableDataset.DATABASE : undefined);
    }
}
